import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/images/Logo-Armony.png'
import _imports_1 from '@/assets/images/Logotype_black.svg'


const _hoisted_1 = {
  class: "flex items-center w-full md:w-auto justify-start",
  href: "/"
}
const _hoisted_2 = { class: "md:flex w-full justify-end items-center hidden" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = ["href", "target", "rel"]
const _hoisted_5 = ["href", "target", "rel"]
const _hoisted_6 = { class: "flex w-full md:w-auto md:ml-8 justify-center md:justify-end" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "h-12 w-12 rounded-full text-gray-100 bg-[#2EC56A] border border-[#2EC56A] flex items-center justify-center group-hover:shadow-md flex-shrink-0" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-duotone fa-wallet" })
], -1)
const _hoisted_8 = { class: "truncate font-poppins px-2 text-white" }
const _hoisted_9 = /*#__PURE__*/_createTextVNode(" Connect ")
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "text-2xl flex text-gray-800 items-center justify-center" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bars-staggered" })
], -1)
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "text-2xl fa-solid fa-x" }, null, -1)
const _hoisted_13 = [
  _hoisted_12
]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = ["href", "target", "rel"]
const _hoisted_16 = ["href", "target", "rel"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", {
    class: _normalizeClass(["w-full flex justify-center items-center font-dm transition-all duration-300 bg-white", _ctx.navAnimationClasses.wrapper])
  }, [
    _createElementVNode("nav", {
      class: _normalizeClass(["xl:mx-10 flex items-center h-16 w-full px-6 transition-all duration-300 container mx-auto", _ctx.navAnimationClasses.nav])
    }, [
      _createElementVNode("a", _hoisted_1, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "logo",
          class: _normalizeClass(["h-12 md:h-36 object-contain w-auto hidden md:block", _ctx.navAnimationClasses.logo])
        }, null, 2),
        _createElementVNode("img", {
          src: _imports_1,
          alt: "logo",
          class: _normalizeClass(["h-12 md:h-36 object-contain w-auto md:hidden", _ctx.navAnimationClasses.logo])
        }, null, 2)
      ]),
      _createElementVNode("div", _hoisted_2, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.local_urls, (e, i) => {
          return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
            (!e.meta.hidden)
              ? (_openBlock(), _createElementBlock("a", _hoisted_3, [
                  _createVNode(_component_router_link, {
                    to: e.path,
                    class: _normalizeClass(["text-gray-600 text-center h-12 px-4 mx-0.5 font-medium flex items-center justify-center md:flex hidden", e.active ?
			                'text-[#B6B6FF] underline decoration-4 decoration-[#B6B6FF] underline-offset-8'
			                : 'hover:bg-gray-100 hover:rounded-full'])
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(e.label), 1)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128)),
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (elem, id) => {
          return (_openBlock(), _createElementBlock(_Fragment, null, [
            (elem?.type && elem.type === 'button')
              ? (_openBlock(), _createElementBlock("a", {
                  key: -id,
                  href: elem.url,
                  target: _ctx.urlsTargets[id].target,
                  rel: _ctx.urlsTargets[id].rel,
                  class: "rounded-full h-12 w-auto text-white flex items-center bg-[#B6B6FF] shadow-md transition-all duration-300 hover:bg-[#a4a4e6] cursor-pointer select-none w-min md:flex hidden whitespace-nowrap mx-0.5 px-4"
                }, _toDisplayString(elem.label), 9, _hoisted_4))
              : (_openBlock(), _createElementBlock("a", {
                  key: id,
                  href: elem.url,
                  target: _ctx.urlsTargets[id].target,
                  rel: _ctx.urlsTargets[id].rel,
                  class: "text-white text-center h-12 px-4 font-medium flex items-center justify-center md:flex hidden hover:bg-gray-900 hover:rounded-full mx-0.5"
                }, _toDisplayString(elem.label), 9, _hoisted_5))
          ], 64))
        }), 256))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.connectionButton.method && _ctx.connectionButton.method(...args))),
          class: _normalizeClass(["flex justify-start items-center bg-[#47D680] hover:bg-[#37C56A] text-white rounded-full tracking-wide font-semibold shadow-lg cursor-pointer transition-all ease-in duration-100 h-auto pr-3 group w-min", _ctx.connectionButton.classes])
        }, [
          _hoisted_7,
          _createElementVNode("p", _hoisted_8, [
            (_ctx.isConnected)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                  _createTextVNode(_toDisplayString(_ctx.connectedAs.slice(0, 5) + "..."), 1)
                ], 64))
              : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _hoisted_9
                ], 64))
          ])
        ], 2)
      ]),
      _createElementVNode("div", {
        class: "text-white md:hidden flex justify-end items-center w-full h-full col-start-4 text-4xl cursor-pointer",
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openMobileNav && _ctx.openMobileNav(...args)))
      }, _hoisted_11),
      _createElementVNode("div", {
        class: _normalizeClass(["fixed top-0 left-0 right-0 h-screen transition-all duration-75 grid grid-rows-6 gap-0", _ctx.navAnimationClasses.mobile.wrapper])
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(Array.from({length: 6}, (v,k) => k), (id) => {
          return (_openBlock(), _createElementBlock("div", {
            key: id,
            class: _normalizeClass(["h-full w-full bg-black transition-all duration-300", [_ctx.navAnimationClasses.mobile.lines.common, _ctx.navAnimationClasses.mobile.lines.items[id]]])
          }, null, 2))
        }), 128)),
        _createElementVNode("div", {
          class: _normalizeClass(["fixed z-20 top-0 left-0 right-0 h-screen flex flex-col transition-all duration-300 text-xl", _ctx.navAnimationClasses.mobile.content])
        }, [
          _createElementVNode("div", {
            class: "ml-auto p-4 cursor-pointer text-white text-4xl mt-3 mr-3",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.closeMobileNav && _ctx.closeMobileNav(...args)))
          }, _hoisted_13),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.local_urls, (e, i) => {
            return (_openBlock(), _createElementBlock(_Fragment, { key: i }, [
              (!e.meta.hidden)
                ? (_openBlock(), _createElementBlock("a", _hoisted_14, [
                    _createVNode(_component_router_link, {
                      to: e.path,
                      onClick: _ctx.closeMobileNav,
                      class: _normalizeClass(["text-white p-8 font-medium flex items-center justify-center border-b", e.active ?
			                'text-[#B6B6FF] underline decoration-4 decoration-[#B6B6FF] underline-offset-8'
			                : ''])
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(e.label), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick", "class"])
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          }), 128)),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.urls, (elem, id) => {
            return (_openBlock(), _createElementBlock(_Fragment, null, [
              (elem?.type && elem.type === 'button')
                ? (_openBlock(), _createElementBlock("a", {
                    key: -id,
                    href: elem.url,
                    target: _ctx.urlsTargets[id].target,
                    rel: _ctx.urlsTargets[id].rel,
                    class: "text-white font-medium rounded-full w-full bg-gray-800 border-2 border-[#B6B6FF] via-[#f56ec6] bg-left flex items-center justify-center md:p-8 px-8 py-4 col-start-8 md:w-1/2 mx-auto mt-6 w-2/3",
                    onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.closeMobileNav && _ctx.closeMobileNav(...args)))
                  }, _toDisplayString(elem.label), 9, _hoisted_15))
                : (_openBlock(), _createElementBlock("a", {
                    key: id,
                    href: elem.url,
                    target: _ctx.urlsTargets[id].target,
                    rel: _ctx.urlsTargets[id].rel,
                    class: "text-white p-8 font-medium flex items-center justify-center border-b",
                    onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.closeMobileNav && _ctx.closeMobileNav(...args)))
                  }, _toDisplayString(elem.label), 9, _hoisted_16))
            ], 64))
          }), 256)),
          _createElementVNode("button", {
            class: "text-white font-medium rounded-full w-full bg-gray-800 border-2 border-[#B6B6FF] via-[#f56ec6] bg-left flex items-center justify-center md:p-8 px-8 py-4 col-start-8 md:w-1/2 mx-auto mt-6 w-2/3",
            onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.onSignInPress && _ctx.onSignInPress(...args)))
          }, " Sign In ")
        ], 2)
      ], 2)
    ], 2)
  ], 2))
}